/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlBase {
    getFixupPrototypeFunction() { return ComplianceControlBase.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlBase>): ComplianceControlBase {
        let obj = Object.assign(new ComplianceControlBase(), model);
        ComplianceControlBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlBase>): ComplianceControlBase {
        if (!model) return null;
        return ComplianceControlBase.newInstance(<ComplianceControlBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlBase) {
        if (!obj) return;

        models.ComplianceControlBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlBase): boolean {
        Object.setPrototypeOf(obj, ComplianceControlBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Dynamic map of control attribute names to values
     */
    control_attributes: { [key: string]: string; };

    /**
     * Dynamic map of action attribute names to values
     */
    control_action_attributes: { [key: string]: string; };

    /**
     * List of policy URIs to map to this control
     */
    policy_mapping: Array<string>;

}
